import { useEffect, useState } from 'react'

export default function useRecaptchaLoader() {
  const [loaded, setLoaded] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (typeof window === 'undefined') return

    const siteKey = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY_V3
    if (!siteKey) {
      return
    }

    if (window.grecaptcha && window.grecaptcha.execute) {
      setLoaded(true)
      return
    }

    // If a recaptcha script is already present, poll for grecaptcha to become available
    const existing = Array.from(document.getElementsByTagName('script')).find(s => s.src && s.src.includes('recaptcha/api.js'))
    if (existing) {
      let mounted = true
      const interval = setInterval(() => {
        if (!mounted) return clearInterval(interval)
        if (window.grecaptcha && window.grecaptcha.execute) {
          setLoaded(true)
          clearInterval(interval)
        }
      }, 250)
      return () => {
        mounted = false
        clearInterval(interval)
      }
    }

    const script = document.createElement('script')
    script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`
    script.async = true
    script.defer = true
    script.onload = () => {
      try {
        if (window.grecaptcha && window.grecaptcha.execute) {
          window.grecaptcha.ready(() => setLoaded(true))
        } else {
          // fallback poll
          let count = 0
          const interval = setInterval(() => {
            if (window.grecaptcha && window.grecaptcha.execute) {
              clearInterval(interval)
              window.grecaptcha.ready(() => setLoaded(true))
            }
            count++
            if (count > 40) {
              clearInterval(interval)
              setError(new Error('grecaptcha not available after load'))
            }
          }, 250)
        }
      } catch (err) {
        setError(err)
      }
    }
    script.onerror = err => setError(err || new Error('recaptcha script failed to load'))
    document.head.appendChild(script)

    return () => {}
  }, [])

  return { loaded, error }
}
